<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.isReview"
        placeholder="人工复核"
        clearable
      >
        <el-option
          v-for="(item, i) in reviewData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.displayStatus"
        placeholder="全部状态"
      >
        <el-option
          v-for="(item, i) in displayData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        clearable
        prefix-icon="el-icon-search"
        v-model="filters.name"
        placeholder="评论内容|资源名称|评论人"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn :title="'重置'" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import Bus from "./Bus.js";
import { getDataMap } from "@/api/sysParam";
export default {
  name: "search",
  components: {
    butn,
  },
  data() {
    return {
      filters: { bizType: 0 },
      displayData: [],
      reviewData: [
        { paramValue: "否", paramKey: "0" },
        { paramValue: "是", paramKey: "1" },
      ],
    };
  },
  created() {
    getDataMap("DISPLAY_STATUS").then((res) => {
      if (!res || res.code != 0) return;
      res.data.splice(0, 0, {
        paramKey: "",
        paramValue: "全部",
      });
      this.displayData = res.data;
    });
    Bus.$on("bizType", (item) => {
      this.filters.bizType = item;
      this.$emit("search", this.filters);
    });
  },
  methods: {
    initData() {
      //查询
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      //重置
      this.filters = { bizType: this.filters.bizType };
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
  },
};
</script>
